import React, { useState, useEffect } from 'react';
import config from '../../config';
import './Attendance.css';
import { MdArrowRight } from "react-icons/md";
import { TbFileText } from "react-icons/tb";
import { CgImport } from "react-icons/cg";
import PaySlip from './PaySlip';
import AttendanceFilter from './AttendanceFilter';
import AttendanceDetail from './AttendanceDetail';
import BiometricDetail from './BiometricDetail';
import { GrNotification } from "react-icons/gr";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FiSearch, FiDownload } from "react-icons/fi";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { BsSliders } from "react-icons/bs";
import Header from "../../components/common/Header";
import { LuCircleDollarSign } from "react-icons/lu";
import { IoFingerPrint } from "react-icons/io5";


const Attendance = ({ setActivePage }) => {
  const [attendanceData, setAttendanceData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 8;
  const [searchTerm, setSearchTerm] = useState('');
  const [searchFilter, setSearchFilter] = useState('');

  const [showBiometric, setShowBiometric] = useState(false);
  const [selectedBiometricEmployee, setSelectedBiometricEmployee] = useState(null);
  const [biometricMonth, setBiometricMonth] = useState(9);
  const [biometricYear, setBiometricYear] = useState(2026);
  // Hardcoded for now - day-wise overrides, remaining working days are "P"
  const biometricData = [
    { id: 1, employeeName: "Varun", overrides: { 9: "L" } },
    { id: 2, employeeName: "Tharun", overrides: { 9: "L" } },
    { id: 3, employeeName: "Selva Kuberan", overrides: {} },
    { id: 4, employeeName: "Shankaran", overrides: { 14: "A" } },
    { id: 5, employeeName: "Aarthy", overrides: {} },
    { id: 6, employeeName: "Raghul", overrides: { 20: "L" } },
    { id: 7, employeeName: "Deepika", overrides: { 13: "L" } },
    { id: 8, employeeName: "Uma Shankar", overrides: {} },
    { id: 9, employeeName: "Arun Kumar", overrides: { 22: "WFH" } },
    { id: 10, employeeName: "Lokesh", overrides: {} },
    { id: 11, employeeName: "Vijaya Sarathy", overrides: { 6: "L" } },
    { id: 12, employeeName: "Naveen Kumar", overrides: {} },
    { id: 13, employeeName: "Magudapathi", overrides: { 16: "A" } },
    { id: 14, employeeName: "Aravindh", overrides: {} },
    { id: 15, employeeName: "Pooja", overrides: { 5: "WFH", 6: "WFH" } },
    { id: 16, employeeName: "Kaviya", overrides: { 5: "WFH", 6: "WFH" } },
    { id: 17, employeeName: "Akash", overrides: {} },
  ];

  const [isFilterOpen, setIsFilterOpen] = useState(false);

  const [showPaySlip, setShowPaySlip] = useState(false);
  const [showImportModal, setShowImportModal] = useState(false);
  const [selectedAttendance, setSelectedAttendance] = useState(null);
  const [selectedClient, setSelectedClient] = useState('');
  const [clientList, setClientList] = useState([]);
  const [selectedClientId, setSelectedClientId] = useState('');

  const [clientLoading, setClientLoading] = useState(false);
  const [clientError, setClientError] = useState(null);
  const [userDetails, setUserDetails] = useState({ name: '', role: '', token: '', orgId: '' });
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [uploadedFile, setUploadedFile] = useState(null);
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [filterValues, setFilterValues] = useState({
    sortBy: "attendanceDate",
    sortOrder: "DESC"
  });
  const [importLoading, setImportLoading] = useState(false);
  const [importError, setImportError] = useState(null);
  const [importSuccess, setImportSuccess] = useState(false);
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1); // Current month (1-12)

  // Get user details from localStorage (like AddRecruitment)
  useEffect(() => {
    const token = localStorage.getItem('Authorization') || '';
    const firstName = localStorage.getItem('firstName') || '';
    const lastName = localStorage.getItem('lastName') || '';
    const role = localStorage.getItem('role')?.toUpperCase() || 'GUEST';
    const orgId = localStorage.getItem('orgId') || '';
    setUserDetails({
      name: `${firstName} ${lastName}`.trim(),
      role,
      token,
      orgId
    });
  }, []);

  // Fetch attendance data from API with search and month parameters
  useEffect(() => {
    const fetchAttendance = async () => {
      try {
        if (!userDetails.orgId || !selectedClientId) return;

        const year = fromDate.split("-")[0];
        const month = fromDate.split("-")[1]; // 03
        console.log('ssssss', year, month, filterValues);
        const params = new URLSearchParams();
        params.append('orgId', userDetails.orgId);
        params.append('clientId', selectedClientId);
        params.append('month', String(month));
        params.append('year', String(year));
        params.append("sortBy", filterValues.sortBy || "attendanceDate");
        params.append("sortOrder", filterValues.sortOrder || "DESC"); // 👈 IMPORTANT

        if (searchTerm) {
          params.append('search', searchTerm);
        }

        const url = `${config.API_BASE_URL}${config.ATTENDENCE_LIST_ENDPOINT}?${params.toString()}`;

        console.log('Final Attendance API:', url);

        const response = await fetch(url, {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${userDetails.token}`,
          },
          credentials: 'include',
        });

        if (!response.ok) {
          throw new Error(`HTTP ${response.status}`);
        }

        const data = await response.json();
        setAttendanceData(Array.isArray(data.body) ? data.body : []);
      } catch (error) {
        console.error('Attendance fetch error:', error);
        setAttendanceData([]);
      }
    };

    if (userDetails.orgId && userDetails.token && selectedClientId) {
      fetchAttendance();
    }
  }, [
    userDetails.orgId,
    userDetails.token,
    selectedClientId,
    searchTerm,
    selectedMonth,
    filterValues,
    fromDate,
    selectedMonth,
    selectedYear  // 🔥 ADD THIS
  ]);

  useEffect(() => {
    const fetchClients = async () => {
      try {
        const orgId = userDetails.orgId;
        if (!orgId || !userDetails.token) return;

        const response = await fetch(
          `${config.API_BASE_URL}${config.CLIENT_LIST_ENDPOINT}${orgId}`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${userDetails.token}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (!response.ok) {
          throw new Error("Failed to fetch clients");
        }

        const data = await response.json();

        // API response array-ah irukum nu assume panren
        setClientList(Array.isArray(data.body) ? data.body : [data]);

      } catch (error) {
        console.error("Client fetch error:", error);
        setClientList([]);
      }
    };

    fetchClients();
  }, [userDetails.orgId, userDetails.token]);


  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    // Implement search logic here
  };

  const handlePaySlip = () => {
    setShowPaySlip(true);
  };

  const handleImport = async () => {
    setShowImportModal(true);
    setClientLoading(true);
    setClientError(null);
    try {
      let url = config.API_BASE_URL + config.CLIENT_LIST_ENDPOINT;
      if (userDetails.orgId) {
        url += userDetails.orgId;
      }
      const headers = {
        'Content-Type': 'application/json',
      };
      if (userDetails.token) {
        headers['Authorization'] = `Bearer ${userDetails.token}`;
      }
      const response = await fetch(url, {
        method: 'GET',
        headers,
        credentials: 'include',
      });
      if (!response.ok) {
        throw new Error(`Failed to fetch clients (HTTP ${response.status})`);
      }
      const data = await response.json();
      const normalized = Array.isArray(data.body)
        ? data.body.filter((c) => c && typeof c.name === 'string').map((c) => ({ name: c.name, clientKey: c.clientKey || c.id || c._id }))
        : [];
      setClientList(normalized);
    } catch (err) {
      setClientError('Could not load clients.');
      setClientList([]);
    } finally {
      setClientLoading(false);
    }
  };

  const handleCloseImportModal = () => {
    setShowImportModal(false);
    setSelectedClient('');
    setFromDate('');
    setToDate('');
    setUploadedFile(null);
    setImportError(null);
    setImportSuccess(false);
  };

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setUploadedFile(file);
    }
  };

  const handleFileDrop = (e) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    if (file) {
      setUploadedFile(file);
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };
  console.log('Selected Client:', selectedClient, userDetails);


  const handleAddImport = async () => {
    setImportLoading(true);
    setImportError(null);

    try {
      if (!selectedClient || !fromDate || !toDate || !uploadedFile) {
        setImportError('All fields are required.');
        setImportLoading(false);
        return;
      }

      const [year, month] = fromDate.split("-");

      const orgId = userDetails.orgId || '6';
      const clientId = selectedClient;

      const url = `${config.API_BASE_URL}${config.ATTENDANCE_UPLOAD_ENDPOINT}/${orgId}/${clientId}`;

      const formData = new FormData();
      formData.append('client', selectedClient);
      formData.append('fromDate', fromDate);
      formData.append('toDate', toDate);
      formData.append('file', uploadedFile);
      formData.append('year', year);
      formData.append('month', Number(month));

      const headers = {};
      if (userDetails.token) {
        headers['Authorization'] = `Bearer ${userDetails.token}`;
      }

      const response = await fetch(url, {
        method: 'POST',
        headers,
        body: formData,
        credentials: 'include',
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(`Failed to import attendance (HTTP ${response.status})`);
      }

      // ✅ Already updated attendance check
      if (
        data?.body?.alreadyUpdatedAttendance &&
        data.body.alreadyUpdatedAttendance.length > 0
      ) {
        const uniqueEmployees = [...new Set(data.body.alreadyUpdatedAttendance)];

        setImportError(
          `Already attendance exists for employee ${uniqueEmployees.join(", ")}`
        );
        return;
      }

      // ✅ Missing employee check
      if (
        data?.body?.missingEmployees &&
        data.body.missingEmployees.length > 0
      ) {
        setImportError(
          `Missing employees: ${data.body.missingEmployees.join(", ")}`
        );
        return;
      }

      toast.success('Attendance imported successfully ');
      handleCloseImportModal();

    } catch (err) {
      setImportError(err.message || 'Import failed.');
    } finally {
      setImportLoading(false);
    }
  };

  const handleFilter = () => {
    setIsFilterOpen(!isFilterOpen);
  };

  const handleApplyFilter = (filters) => {
    setCurrentPage(1);   // reset page
    setFilterValues(filters);
  };


  const handleRowClick = (attendance) => {
    setSelectedAttendance(attendance);
  };

  const filteredData = attendanceData.filter(item => {
    const employeeName = typeof item.employeeName === 'string' ? item.employeeName : '';
    const clientName = typeof item.clientName === 'string' ? item.clientName : '';
    const matchesSearch = employeeName.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesClient = !filterValues.clientName || clientName === filterValues.clientName;
    const matchesEmployee = !filterValues.employeeName || employeeName.toLowerCase().includes(filterValues.employeeName.toLowerCase());
    return matchesSearch && matchesClient && matchesEmployee;
  });

  const filteredBiometricData = biometricData.filter((item) => {
    const employeeName = typeof item.employeeName === 'string' ? item.employeeName : '';
    const matchesSearch = employeeName.toLowerCase().includes(searchTerm.toLowerCase());
    return matchesSearch;
  });

  const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  const weekDayNames = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  const yearOptions = [2024, 2025, 2026, 2027];
  const daysInMonth = new Date(biometricYear, biometricMonth + 1, 0).getDate();
  const monthDays = Array.from({ length: daysInMonth }, (_, i) => {
    const date = new Date(biometricYear, biometricMonth, i + 1);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return {
      day: i + 1,
      weekDay: weekDayNames[date.getDay()],
      isWeekend: date.getDay() === 0 || date.getDay() === 6,
      isFuture: date > today,
    };
  });

  // Hardcoded worked hours for present days, varied per employee/day
  const presentHourOptions = [9, 8, 9, 8, 7, 9, 8, 6];

  const getBiometricStatus = (employee, dayInfo) => {
    if (dayInfo.isWeekend || dayInfo.isFuture) return '';
    if (employee.overrides[dayInfo.day]) return employee.overrides[dayInfo.day];
    const hours = presentHourOptions[(employee.id * 3 + dayInfo.day) % presentHourOptions.length];
    return `${hours}hrs`;
  };

  const getBiometricStatusColor = (status) => {
    if (/^\d+hrs$/.test(status)) return parseInt(status, 10) < 8 ? '#dc2626' : '#16a34a';
    switch (status) {
      case 'L':
        return '#d97706';
      case 'WFH':
        return '#2563eb';
      case 'A':
        return '#dc2626';
      default:
        return '#4b5563';
    }
  };

  const handleBiometricDownload = async () => {
    try {
      const monthLabel = monthNames[biometricMonth];
      const workbook = new ExcelJS.Workbook();
      const sheet = workbook.addWorksheet(`${monthLabel} ${biometricYear}`);

      sheet.addRow(['', ...monthDays.map((d) => d.weekDay)]);
      sheet.addRow(['Employee Name', ...monthDays.map((d) => `${monthLabel.slice(0, 3)} ${d.day}`)]);
      filteredBiometricData.forEach((employee) => {
        sheet.addRow([employee.employeeName, ...monthDays.map((d) => getBiometricStatus(employee, d))]);
      });

      sheet.getColumn(1).width = 22;
      monthDays.forEach((d, idx) => {
        const column = sheet.getColumn(idx + 2);
        column.width = 11;
        column.alignment = { horizontal: 'center' };
        if (d.isWeekend) {
          column.eachCell({ includeEmpty: true }, (cell) => {
            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE8F3E1' } };
          });
        }
      });
      sheet.getRow(1).font = { bold: true };
      sheet.getRow(2).font = { bold: true };
      sheet.views = [{ state: 'frozen', xSplit: 1, ySplit: 2 }];

      sheet.eachRow((row, rowNumber) => {
        if (rowNumber <= 2) return;
        row.eachCell((cell, colNumber) => {
          if (colNumber === 1) return;
          cell.font = { bold: true, color: { argb: `FF${getBiometricStatusColor(cell.value).slice(1)}` } };
        });
      });

      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      saveAs(blob, `Biometric_Attendance_${monthLabel}_${biometricYear}.xlsx`);
    } catch (error) {
      console.error('Biometric download failed:', error);
      toast.error('Failed to download biometric attendance');
    }
  };

  const activeDataLength = showBiometric ? filteredBiometricData.length : filteredData.length;
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentAttendance = filteredData.slice(
    indexOfFirstItem,
    indexOfLastItem
  );
  const currentBiometricAttendance = filteredBiometricData.slice(
    indexOfFirstItem,
    indexOfLastItem
  );

  // Pagination logic for showing only 3 pages at a time
  const totalPages = Math.max(1, Math.ceil(activeDataLength / itemsPerPage));
  const pageGroupSize = 3;
  const currentGroup = Math.floor((currentPage - 1) / pageGroupSize);
  const groupStart = currentGroup * pageGroupSize + 1;
  const groupEnd = Math.min(groupStart + pageGroupSize - 1, totalPages);
  const pageNumbers = [];
  for (let i = groupStart; i <= groupEnd; i++) {
    pageNumbers.push(i);
  }

  if (showPaySlip) {
    return <PaySlip onCancel={() => setShowPaySlip(false)} />;
  }

  if (selectedAttendance) {
    return (
      <AttendanceDetail
        attendance={selectedAttendance}
        onClose={() => setSelectedAttendance(null)}
      />
    );
  }

  if (selectedBiometricEmployee) {
    return (
      <BiometricDetail
        employee={selectedBiometricEmployee}
        onClose={() => setSelectedBiometricEmployee(null)}
      />
    );
  }

  return (
    <div>
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} newestOnTop closeOnClick pauseOnFocusLoss draggable pauseOnHover />

      <Header
        title={showBiometric ? "Biometric Attendance list" : "Attendance list"}
        subtitle={showBiometric ? "Biometric check-in and check-out logs" : "Attendance information"}
        onProfileClick={() => setActivePage && setActivePage("Profile")}
      />

      <div className='table-container'>
        <div className='table-controls'>
          <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>

            {/* Search box */}
            <div className="search-wrapper">
              <FiSearch className="search-icon" />
              <input
                type='text'
                className='search-input-with-icon'
                placeholder='Search'
                value={searchTerm}
                onChange={handleSearch}
              />
            </div>

            {showBiometric ? (
              <>
                {/* Month & Year filter */}
                <select
                  className="search-input"
                  style={{ width: '140px', marginTop: 19, height: '37px' }}
                  value={biometricMonth}
                  onChange={(e) => {
                    setBiometricMonth(Number(e.target.value));
                    setCurrentPage(1);
                  }}
                >
                  {monthNames.map((name, idx) => (
                    <option key={name} value={idx}>{name}</option>
                  ))}
                </select>
                <select
                  className="search-input"
                  style={{ width: '100px', marginTop: 19, height: '37px' }}
                  value={biometricYear}
                  onChange={(e) => {
                    setBiometricYear(Number(e.target.value));
                    setCurrentPage(1);
                  }}
                >
                  {yearOptions.map((year) => (
                    <option key={year} value={year}>{year}</option>
                  ))}
                </select>
              </>
            ) : (
              // Date Picker Wrapper
              <div className="date-picker-wrapper">
                <input
                  type={fromDate ? "month" : "text"} // Value iruntha month type, illana text type (neat-ah irukum)
                  placeholder="Select Month"
                  onFocus={(e) => (e.target.type = "month")}
                  onBlur={(e) => { if (!e.target.value) e.target.type = "text"; }}
                  className="search-input custom-date-picker"
                  style={{
                    width: '160px',
                    height: '37px',
                    marginTop: '19px',
                    padding: '0 10px'
                  }}
                  value={fromDate}
                  onChange={(e) => setFromDate(e.target.value)}
                />
              </div>
            )}

          </div>

          <div className='button-container attendance-actions'>
            <select
              className="search-input attendance-control"
              style={{ width: '180px' }}
              value={selectedClientId}
              onChange={(e) => setSelectedClientId(e.target.value)}
            >
              <option value="">All Clients</option>
              {clientList.map(client => (
                <option key={client.clientKey} value={client.clientKey}>
                  {client.name}
                </option>
              ))}
            </select>

            <button
              type="button"
              className={`fingerprint-btn attendance-control ${showBiometric ? 'active' : ''}`}
              title={showBiometric ? "View Attendance List" : "View Biometric Attendance"}
              onClick={() => {
                setShowBiometric((prev) => !prev);
                setCurrentPage(1);
              }}
            >
              <IoFingerPrint size={22} />
            </button>

            {showBiometric && (
              <button
                type="button"
                className="fingerprint-btn attendance-control"
                title="Download as Excel"
                onClick={handleBiometricDownload}
              >
                <FiDownload size={18} />
              </button>
            )}

            {!showBiometric && (
              <>
                <button className='add-client-btn attendance-control' onClick={handlePaySlip}>
                  <LuCircleDollarSign size={15} />
                  Pay Slip
                </button>
                <button className='add-client-btn attendance-control' onClick={handleImport}>
                  <CgImport size={15} />
                  Import
                </button>
              </>
            )}
            <button className='filter-btn attendance-control' onClick={handleFilter}>
              <BsSliders />
              Filter
            </button>
          </div>
        </div>


        {showBiometric ? (
          <div className={`biometric-grid-wrapper ${currentBiometricAttendance.length === itemsPerPage ? 'biometric-grid-fill' : ''}`}>
            <table className='table biometric-grid'>
              <thead>
                <tr>
                  <th className='th biometric-sticky-col' rowSpan={2}>Employee Name</th>
                  {monthDays.map((d) => (
                    <th key={`wd-${d.day}`} className={`th biometric-day-head ${d.isWeekend ? 'biometric-weekend' : ''}`}>
                      {d.weekDay}
                    </th>
                  ))}
                </tr>
                <tr>
                  {monthDays.map((d) => (
                    <th key={`dt-${d.day}`} className={`th biometric-date-head ${d.isWeekend ? 'biometric-weekend' : ''}`}>
                      {monthNames[biometricMonth].slice(0, 3)} {d.day}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {currentBiometricAttendance.length > 0 ? (
                  currentBiometricAttendance.map((item, idx) => (
                    <tr
                      key={item.id || idx}
                      onClick={() => setSelectedBiometricEmployee(item)}
                      style={{ cursor: 'pointer' }}
                      title="Click to view daily biometric log"
                    >
                      <td className='td biometric-sticky-col'>{item.employeeName || '-'}</td>
                      {monthDays.map((d) => {
                        const status = getBiometricStatus(item, d);
                        return (
                          <td
                            key={d.day}
                            className={`td ${d.isWeekend ? 'biometric-weekend' : ''}`}
                            style={{ color: getBiometricStatusColor(status), fontWeight: 600 }}
                          >
                            {status}
                          </td>
                        );
                      })}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={daysInMonth + 1} className='td' style={{ textAlign: 'center', padding: '24px' }}>
                      No biometric records found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        ) : (
          <table className='table'>
            <thead>
              <tr>
                <th className='th'>Employee Name</th>
                <th className='th'>Date</th>
                <th className='th'>Shift Name</th>
                <th className='th'>Work Hours</th>
                <th className='th'>OT Hours</th>
                <th className='th'>Pay day</th>
                <th className='th'>Client Name</th>
              </tr>
            </thead>
            <tbody>
              {currentAttendance.map((item, idx) => (
                <tr key={item.id || idx} onClick={() => handleRowClick(item)} style={{ cursor: 'pointer' }}>
                  <td className='td' style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <MdArrowRight />

                    <span>{item.employeeName || '-'}</span>
                  </td>
                  <td className='td'>{item.date || '-'}</td>
                  <td className='td'>{item.shiftName || '-'}</td>
                  <td className='td'>{item.workHours != null ? item.workHours : '-'}</td>
                  <td className='td'>{item.otHours != null ? item.otHours : '-'}</td>
                  <td className='td'>{item.payDay != null ? item.payDay : '-'}</td>
                  <td className='td'>{item.clientName || '-'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}

        <div className='table-footer'>
          <div className='record-count'>
            Showing {activeDataLength === 0 ? 0 : indexOfFirstItem + 1} to{" "}
            {Math.min(indexOfLastItem, activeDataLength)} of{" "}
            {activeDataLength} entries
          </div>

          <div className='pagination'>
            {/* Prev group arrow */}
            <button
              className='pagination-button'
              disabled={groupStart === 1}
              onClick={() => {
                if (groupStart > 1) setCurrentPage(groupStart - 1);
              }}
            >
              &lt;
            </button>

            {/* Page numbers in current group */}
            {pageNumbers.map((num) => (
              <button
                key={num}
                className={`pagination-button ${currentPage === num ? "active" : ""}`}
                onClick={() => setCurrentPage(num)}
              >
                {num}
              </button>
            ))}

            {/* Next group arrow */}
            <button
              className='pagination-button'
              disabled={groupEnd === totalPages}
              onClick={() => {
                if (groupEnd < totalPages) setCurrentPage(groupEnd + 1);
              }}
            >
              &gt;
            </button>
          </div>
        </div>
      </div>

      {showImportModal && (
        <>
          <div className="modal-backdrop" onClick={handleCloseImportModal}></div>
          <div className="import-modal">
            <h3 className="modal-title">Import</h3>
            <div className="modal-form">
              {importSuccess && (
                <div className="modal-success" style={{ color: 'green', marginBottom: 8 }}>
                  Attendance imported successfully
                </div>
              )}
              <label className="modal-label">Client</label>
              <div className="select-wrapper">
                <select
                  className="modal-select"
                  value={selectedClient}
                  onChange={(e) => setSelectedClient(e.target.value)}
                  disabled={clientLoading || !!clientError || importLoading}
                >
                  <option value="">
                    {clientLoading
                      ? 'Loading clients...'
                      : clientError
                        ? 'Failed to load clients'
                        : ''}
                  </option>
                  {!clientLoading && !clientError && clientList.map((client) => (
                    console.log('Client in list:', client),
                    <option key={client.clientKey ?? client.name} value={client.clientKey}>
                      {client.name}
                    </option>
                  ))}
                </select>
              </div>
              <label className="modal-label">From Date</label>
              <input
                type="date"
                className="modal-input"
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
                disabled={importLoading}
              />
              <label className="modal-label">To Date</label>
              <input
                type="date"
                className="modal-input"
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
                disabled={importLoading}
              />
              <div
                className="file-upload-area"
                onDrop={handleFileDrop}
                onDragOver={handleDragOver}
                onClick={() => document.getElementById('file-input').click()}
                style={{ opacity: importLoading ? 0.6 : 1, pointerEvents: importLoading ? 'none' : 'auto', height: '100px' }}
              >
                <div className="upload-icon">
                  <svg width="36" height="36" viewBox="0 0 36 36" fill="none">
                    <circle cx="18" cy="18" r="18" fill="#3B82F6" />
                    <path d="M18 12v12M12 18h12" stroke="white" strokeWidth="2" strokeLinecap="round" />
                  </svg>
                </div>
                <p className="upload-text">
                  Drag & Drop or <span className="upload-link">choose file</span> to upload
                </p>
                <p className="upload-format">{uploadedFile ? uploadedFile.name : 'XLXS/CSV/XLS'}</p>
              </div>
              <input
                type="file"
                id="file-input"
                style={{ display: 'none' }}
                accept=".xlsx,.csv,.xls"
                onChange={handleFileUpload}
                disabled={importLoading}
              />
              {importError && <div className="modal-error" style={{ color: 'red', marginTop: 8 }}>{importError}</div>}
              <div className="modal-actions">
                <button className="modal-cancel-btn" onClick={handleCloseImportModal} disabled={importLoading}>
                  Cancel
                </button>
                <button className="modal-add-btn" onClick={handleAddImport} disabled={importLoading}>
                  {importLoading ? 'Adding...' : 'Add'}
                </button>
              </div>
            </div>
          </div>
        </>
      )}

      <AttendanceFilter
        visible={isFilterOpen}
        onClose={() => setIsFilterOpen(false)}
        onApply={handleApplyFilter}
      />
    </div>
  );
};

export default Attendance;
